<template>
    <div style="padding: 10px 10px 10px 0;">
        <el-tabs v-model="activeName2" @tab-click="handleClick2">
            <el-tab-pane label="日历视图" name="日历视图">
                <div class="one">
                    <div>
                        <el-calendar style="width:650px;" v-model="dateValue" value-format="yyyy-MM-dd">
                            <template slot="dateCell" slot-scope="{date, data}">
                                <div>
                                    <div :class="data.isSelected ? 'is-selected' : ''"> {{
                                        data.day.split('-').slice(1).join('-')
                                    }} </div>
                                    <div class="oneItem">
                                        {{ data.isSelected ? '✔️' : '' }}
                                    </div>
                                </div>

                            </template>
                        </el-calendar>

                    </div>
                    <el-divider direction="vertical"></el-divider>

                    <div>
                        <div style="margin-top:20px;">早班</div>
                        <el-divider></el-divider>
                        <div style="line-height: 50px;">
                            <!-- <i style="font-size: 16px;" class="el-icon-star-on"></i> -->
                            <!-- <el-button slot="reference" @click="openShow1()">张菲菲</el-button> -->

                            <el-button slot="reference" @click="openShow1(item)" v-for="item in zList">
                                {{ item.userName }}
                                <i v-if="item.leaderFlag == 1" style="font-size: 16px;" class="el-icon-star-on"></i>
                            </el-button>

                            <el-button round @click="addRow1('z')">添加</el-button>
                        </div>
                        <div style="margin-top:20px;">白班</div>
                        <el-divider></el-divider>
                        <div style="line-height: 50px;">
                            <!-- <i style="font-size: 16px;" class="el-icon-star-on"></i> -->
                            <!-- <el-button slot="reference" @click="openShow1()">张菲菲</el-button> -->

                            <el-button slot="reference" @click="openShow1(item)" v-for="item in dayList">
                                {{ item.userName }}
                                <i v-if="item.leaderFlag == 1" style="font-size: 16px;" class="el-icon-star-on"></i>
                            </el-button>

                            <el-button round @click="addRow1('d')">添加</el-button>
                        </div>
                        <div style="margin-top:20px;">晚班</div>
                        <el-divider></el-divider>
                        <div style="line-height: 50px;">

                            <el-button slot="reference" @click="openShow1(item)" v-for="item in nightList">{{
                                item.userName
                            }} <i v-if="item.leaderFlag == 1" style="font-size: 16px;"
                                    class="el-icon-star-on"></i></el-button>
                            <el-button round @click="addRow1('n')">添加</el-button>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="列表视图" name="列表视图">
                <el-form :inline="true" :model="selectForm" ref="selectForm">
                    <el-form-item label="日期" prop="queryDate">
                        <el-date-picker clearable size="small" v-model="queryDate" type="daterange" align="right"
                            unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="pickerOptions" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="getAll">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary"
                            @click="$refs.selectForm.resetFields(); query();">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="handleDown">导入模版下载</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="handleImport">导入</el-button>
                        <!-- <el-button size="small" type="primary" v-if="activeName == '保洁计划'"
                            @click="$refs.selectForm.resetFields(); getAll();">导入</el-button>
                        <el-button size="small" type="primary" v-if="activeName == '值班经理'"
                            @click="$refs.selectForm.resetFields(); getAll();">导入</el-button> -->
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="addRow">新增</el-button>
                    </el-form-item>
                    <!-- <el-form-item>
    				<el-button type="primary" @click="dc">导出</el-button>
    			</el-form-item> -->
                </el-form>
                <!-- 表格 -->
                <el-table :data="data1" style="width: 100%">
                    <el-table-column prop="onDutyDate" label="日期" align="center"></el-table-column>
                    <el-table-column prop="shift" label="班次" align="center"></el-table-column>
                    <!-- <el-table-column prop="name" label="角色" align="center"></el-table-column> -->
                    <el-table-column prop="userName" label="姓名" align="center"></el-table-column>
                    <!-- <el-table-column prop="leaderFlag" label="职责" align="center"></el-table-column> -->
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="edit2(scope.row)">编辑</el-button>
                            <el-button type="text" @click="del2(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination v-if="totalNum > 0" @size-change="sizeChange" @current-change="currentChange"
                    :page-sizes="[10, 20, 30, 40]" :page-size="selectForm.rows"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalNum" style="margin-top: 10px;">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>

        <el-dialog :title="show1Obj.userName" :visible.sync="show1" width="400px" center>
            <!-- <div style="text-align: center;">指责：{{ show1Obj.leaderFlag }}</div> -->
            <div style="text-align: center;">班次：{{ show1Obj.shift }}</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="del2(show1Obj)">移 除</el-button>
                <el-button type="primary" @click="edit2(show1Obj)">换 班</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="upload.title" :visible.sync="upload.open" width="400px" append-to-body>
            <div style="margin-bottom:20px;">
                <span>月份：</span>
                <el-date-picker value-format="yyyy-MM" size="small" v-model="paramsData.date" type="month"
                    placeholder="选择月">
                </el-date-picker>
            </div>

            <el-upload ref="upload" :limit="1" accept=".xlsx, .xls" :headers="upload.headers" :action="upload.url"
                :disabled="upload.isUploading" :on-progress="handleFileUploadProgress" :on-success="handleFileSuccess"
                drag :data="paramsData" :before-upload="beforeAvatarUpload" :auto-upload="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <span>仅允许导入xls、xlsx格式文件。</span>

                <!--  <div class="el-upload__tip text-center" slot="tip">
                    <div class="el-upload__tip" slot="tip">

                    </div>
                   <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;"
                        @click="importTemplate">下载模板</el-link> 
                </div>-->
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button v-if="!upload.isUploading" size="small" type="primary" @click="submitFileForm">确
                    定</el-button>
                <el-button v-else type="primary" size="small" :loading="true">导入中</el-button>
                <el-button size="small" @click="upload.open = false">取 消</el-button>
            </div>
        </el-dialog>


        <el-dialog :title="title" :visible.sync="show" width="500px"  :modal-append-to-body="false">
            <el-form label-width="100px" :model="form2" ref="form2">
                <el-form-item label="日期" prop="onDutyDate">
                    <!-- <el-input v-model="form2.onDutyDate" placeholder="请输入路线名称"></el-input> -->
                    <el-date-picker size="small" v-model="form2.onDutyDate" type="date" placeholder="选择日期"
                        value-format="yyyy-MM-dd" style="width: 100%;" />
                </el-form-item>
                <el-form-item label="班次类型" prop="shift">
                    <el-select style="width:100%" v-model="form2.shift" placeholder="请选择班次类型">
                        <el-option v-for="item in typeList" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="人员" prop="userName">
                    <el-select style="width:100%" filterable v-model="form2.userName" placeholder="请选择人员">
                        <el-option v-for="item in userList" :label="item.userName" :value="item.userName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设为队长" prop="leaderFlag">
                    <el-switch v-model="form2.leaderFlag" active-color="#13ce66" :active-value="1" :inactive-value="0">
                    </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="show = false;">取 消</el-button>
                <el-button size="small" type="primary" @click="submit2">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
export default {
    data() {
        return {
            show1Obj: {},
            dayList: [],
            nightList: [],
            show1: false,
            title: "",
            form2: {
                "id": "",
                "leaderFlag": 0,
                "onDutyDate": "",
                "onDutyType": 0,
                "shift": "",
                "userId": "",
                "userName": ""
            },
            typeList: [],
            userList: [],
            paramsData: { date: "" },
            // 用户导入参数
            upload: {
                // 是否显示弹出层（用户导入）
                open: false,
                // 弹出层标题（用户导入）
                title: "",
                // 是否禁用上传
                isUploading: false,

                // 设置上传的请求头部
                headers: {
                    Authorization: localStorage.access_token
                },
                // 上传的地址
                url: ""
            },
            totalNum: 0,
            zList: [],
            dateValue: this.getDate(),
            activeName: "3",
            activeName2: "日历视图",
            data1: [], //表格数据
            selectForm: { //查询条件
                page: 1, //当前页
                rows: 10, //页大小
            },
            queryDate: [], //查询日期
            show: false, //控制弹窗
            title: "新增",
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    watch: {
        dateValue(val) {
            this.toDay();
        }
    },
    methods: {
        addRow1(shift) {

            this.title = "新增"

            this.form2 = {
                "id": "",
                "leaderFlag": 0,
                "onDutyDate": this.dateFormat(this.dateValue),
                "onDutyType": Number(this.activeName),
                "shift": shift,
                "userId": "",
                "userName": ""
            };
            this.show = true;
        },
        addRow() {
            this.title = "新增"
            this.form2 = {
                "id": "",
                "leaderFlag": 0,
                "onDutyDate": "",
                "onDutyType": Number(this.activeName),
                "shift": "",
                "userId": "",
                "userName": ""
            };
            this.show = true;
        },
        openShow1(item) {
            this.show1Obj = item
            this.show1 = true;
        },
        edit2(row) {
            this.title = "修改"
            this.form2 = {
                "id": "",
                "leaderFlag": 0,
                "onDutyDate": "",
                "onDutyType": Number(this.activeName),
                "shift": "",
                "userId": "",
                "userName": ""
            };
            let row1 = JSON.parse(JSON.stringify(row))
            this.form2.id = row1.id
            this.form2.onDutyDate = row1.onDutyDate
            this.form2.shift = row1.shift
            this.form2.leaderFlag = Number(row1.leaderFlag)
            this.form2.userName = row1.userName
            this.form2.userId = row1.userId
            this.show = true;
        },
        submit2() {
            if (this.form2.onDutyDate == "") {
                this.$message.error('请选择日期!');
                return false;
            }
            if (this.form2.shift == "") {
                this.$message.error('请选择班次!');
                return false;
            }
            if (this.form2.userName == "") {
                this.$message.error('请选择人员!');
                return false;
            }
            let url = "/api/inspect/insert"
            if (this.form2.id) {
                url = "/api/inspect/update"
            }
            this.$http.post(url, this.form2).then(res => {
                console.log(res)
                if (res.data.code == 0) {
                    this.$message.success(res.data.data)
                    this.show = false;
                    if (this.activeName2 == '列表视图') {
                        this.query();
                    } else {
                        this.show1 = false;
                        this.toDay();
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        del2(row) {
            this.$confirm('确定该删除该数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.delete(`/api/inspect/delete?id=${row.id}`, {}).then(res => {
                    if (res.data.code == 0) {

                        this.$message.success("删除成功")

                        if (this.activeName2 == '列表视图') {
                            this.query();
                        } else {
                            this.show1 = false;
                            this.toDay();
                        }
                    } else {
                        this.$message.error("删除失败")
                    }
                })
            })
        },
        //时间格式化函数，此处仅针对yyyy-MM-dd hh:mm:ss 的格式进行格式化
        dateFormat: function (time) {
            var date = new Date(time);
            var year = date.getFullYear();
            /* 在日期格式中，月份是从0开始的，因此要加0
             * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
             * */
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            // 拼接
            // +" "+hours+":"+minutes+":"+seconds
            return year + "-" + month + "-" + day;
        },
        toDay() {
            this.dayList = []
            this.nightList = []
            this.zList = []
            this.$http.post(`/api/inspect/querylistByDate`, { date: this.dateFormat(this.dateValue), onDutyType: Number(this.activeName) }).then(res => {
                if (res.data.code == 0) {
                    this.zList = res.data.data.zList;
                    this.dayList = res.data.data.dayList;
                    this.nightList = res.data.data.nightList;
                } else {
                    this.$message.error(res.data.message)
                }

            })
        },
        getDate() {
            const nowDate = new Date();
            const date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate(),
            };
            const newmonth = date.month >= 10 ? date.month : "0" + date.month;
            const day = date.date >= 10 ? date.date : "0" + date.date;
            return date.year + "-" + newmonth + "-" + day;
        },
        query() {

            this.queryDate = [];
            this.selectForm.page = 1 //查询条件
            this.getAll();
        },
        handleClick() {
            this.dateValue = this.getDate();
            this.getUserList();
            this.toDay();
            this.selectForm.page = 1 //查询条件
            this.activeName2 = "日历视图"
        },
        handleClick2() {
            if (this.activeName2 == '列表视图') {
                this.query();

            } else {
                this.toDay();
            }

        },
        getAll() { //获取表格数据
            if (this.queryDate && this.queryDate.length == 2) {
                this.selectForm.startDate = this.queryDate[0]
                this.selectForm.endDate = this.queryDate[1]
            } else {
                this.selectForm.startDate = ""
                this.selectForm.endDate = ""
            }
            this.selectForm.onDutyType = this.activeName;
            this.data1 = []
            this.$http.post(`/api/inspect/list`, this.selectForm).then(res => {
                if (res.data.code == 0) {
                    this.data1 = res.data.data.items;
                    this.totalNum = res.data.data.totalNum;
                } else {
                    this.$message.error("查询失败")
                }
            })
        },
        sizeChange(size) { //页大小被修改
            this.selectForm.rows = size;
            this.getAll();
        },
        currentChange(page) { //当前页被修改
            this.selectForm.page = page;
            this.getAll();
        },
        handleDown(){
            this.$http.post(`/api/inspect/downloadGC`, {}, {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=utf-8",
				},
				responseType: "blob"
			}).then(res => {
				const link = document.createElement("a");
				let blob = new Blob([res.data], {
					type: "application/vnd.ms-excel"
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.download = "排班计划导入模板.xls";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
        },
        /** 导入按钮操作 */
        handleImport() {
            this.upload.title = "导入";
            this.paramsData.date = ""
            this.upload.open = true;
            this.upload.url = "/api/admin/inspect/uploadGC"
        },
        // 文件上传中处理
        handleFileUploadProgress(event, file, fileList) {
            this.upload.isUploading = true;
        },
        // 文件上传成功处理
        handleFileSuccess(response, file, fileList) {
            this.upload.open = false;
            this.upload.isUploading = false;
            this.$refs.upload.clearFiles();
            if (response.code == 0) {
                this.$message.success(`共导入数据${response.data}条!`);
                this.getAll();

            } else {
                this.$message.error(`${response.message}`);
            }
        },
        // 提交上传文件
        submitFileForm() {
            if (this.paramsData.date == "") {
                this.$message.error('请选择导入的月份!');
                return false;
            }
            this.$refs.upload.submit();
        },
        // 上传之前
        beforeAvatarUpload(file) {
            if (this.paramsData.date == "") {
                this.$message.error('请先选择导入的月份!');
                return false;
            }
            return true;
        },
        getUserList() {
            this.$http.get(`/api/inspect/queryUserName?onDutyType=` + Number(this.activeName), {}).then(res => {
                if (res.data.code == 0) {
                    this.userList = res.data.data;
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        getTypeList() {
            this.$http.post(`/api/inspect/shiftConfig/getTypes`, {}).then(res => {
                if (res.data.code == 200) {
                    for (let key in res.data.data) {
                        let data = {
                            label: res.data.data[key],
                            value: key
                        }
                        this.typeList.push(data)
                    }
                }

            })
        },
    },
    created() {
        this.toDay();
        this.getUserList();
        this.getTypeList();
    }
}
</script>

<style scoped="scoped">
.one {
    display: flex;
}

.oneItem {
    width: 100%;
    /* text-align: center; */
}

.one .is-selected {
    color: #1989FA;
}
</style>
